import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Switch,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CancelIcon from "@mui/icons-material/Cancel";

import FilterModal from "../../../src/Components/Modal/Filter";
import ReportFilter from "../../../src/Components/Modal/ReportFilter";
import DropdownComponent from "./DropdownComponent";

// Component
const TopButton = (props) => {
  // const [defaultSelectedVal, setDefaultSelectedVal] = useState(null);
  const [isActiveData, setIsActiveData] = useState(props.defaultActiveUsers);

  const handleIsActive = (val) => {
    props.pressParentIsActive(val);
    setIsActiveData(val);
  };

  return (
    <Grid
      container
      sx={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: 1,
        borderBottomColor: "#D9D9D9",
        pb: 1,
        px: 3,
      }}
    >
      <Grid item>
        <Box>
          {props.title && (
            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  color: "#5f5600ff",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                }}
              >
                {props.title ? props.title : ""}
              </Typography>
              {props.secondaryText && (
                <Typography
                  sx={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.8rem",
                    "@media (min-width: 1636px)": { fontSize: "1rem" },
                  }}
                >
                  {props.secondaryText}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Grid>
      {props.centerText && (
        <Grid
          item
          sx={{
            color: "#5f5600ff",
            fontWeight: "600",
            fontSize: "1.1rem",
          }}
        >
          {props.centerText}
        </Grid>
      )}
      <Grid item>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {props.downloadIcon && process.env.REACT_APP_DOWNLOAD_ALLOW == 'true' && (
            <IconButton color="primary" onClick={props.pressTopBtn}>
              <CloudDownloadIcon sx={{ fontSize: "2.4vw" }} />
            </IconButton>
          )}
          {props.isActiveUsers && (
            <Box sx={{ mt: 1 }}>
              {props.activeText}
              <Switch
                checked={isActiveData}
                size="small"
                inputProps={{ "aria-label": "controlled" }}
                color="primary"
                onChange={() => {
                  handleIsActive(!isActiveData);
                }}
              />
            </Box>
          )}
          {props.dropDownData && props.dropDownData.length > 0 && (
            <DropdownComponent
              defaultSelected={props.dropDownData[0]}
              dropDownData={props.dropDownData}
              fetchBySelectedValue={props.fetchBySelectedValue}
              disableVal={false}
            />
          )}
          {props.textTitleBtn && (
            <Button
              sx={{
                backgroundColor: "#F5F5F5",
                textTransform: "inherit",
                borderRadius: 10,
                fontWeight: "600",
                mx: 1,
                
                "@media (min-width: 1636px)": { fontSize: "1.2rem", px: 2 },
              }}
              onClick={props.pressTitleBtn}
            >
              {props.textTitleBtn}
            </Button>
          )}
          {props.buttonText && (
            <Button
              sx={{
                backgroundColor: "#F5F5F5",
                textTransform: "inherit",
                borderRadius: 10,
                fontWeight: "600",
                mx: 1,
                
                "@media (min-width: 1636px)": { fontSize: "1.2rem", px: 2 },
              }}
              onClick={props.press}
            >
              {props.buttonText}
            </Button>
          )}
          {props.buttonText1 && (
            <Button
              sx={{
                backgroundColor: "#F5F5F5",
                textTransform: "inherit",
                borderRadius: 10,
                fontWeight: "600",
                mx: 1,
               
                "@media (min-width: 1636px)": { fontSize: "1.2rem", px: 2 },
              }}
              onClick={props.press1}
            >
              {props.buttonText1}
            </Button>
          )}

          {props.isLearnerFilter && (
            <FilterModal
              press={props.handleFilterReport}
              defaultSelectedValues={props.defaultSelectedValues}
              isAllTrainer={true}
            />
          )}
          {props.isReportFilter && (
            <ReportFilter
              press={props.handleFilter}
              classesHide={props.classesHide}
              searchLabel={props.searchLabel}
            />
          )}
          {props.closeIcon && (
            <IconButton color="primary" onClick={props.pressCloseBtn}>
              <CancelIcon sx={{ fontSize: "2.3vw" }} />
            </IconButton>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
export default TopButton;
